import { render } from "./ThreeJSModel.vue?vue&type=template&id=ed5dd4ba&scoped=true"
import script from "./ThreeJSModel.vue?vue&type=script&lang=js"
export * from "./ThreeJSModel.vue?vue&type=script&lang=js"

import "./ThreeJSModel.vue?vue&type=style&index=0&id=ed5dd4ba&lang=scss&scoped=true"
import "./ThreeJSModel.vue?vue&type=style&index=1&id=ed5dd4ba&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5dd4ba"]])

export default __exports__